import React from 'react';
import { Outlet } from 'react-router-dom';
import icon from '../../assets/images/archieIcon.svg';
import iconDark from '../../assets/images/archieIconDark.svg';
import wordmark from '../../assets/images/archieWordmark.svg';
import wordmarkDark from '../../assets/images/archieWordmarkDark.svg';
import Footer from '../../components/footer/Footer';

const AuthPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-(--color-surface-subtle)">
      <main id="main-content" className="flex flex-col items-center min-h-full break-words flex-1">
        <div className="flex flex-col items-center mt-20 mb-4 max-w-[80%]">
          <img src={icon} width={160} alt="Archie" className="dark:hidden" />
          <img src={iconDark} width={160} alt="Archie" className="hidden dark:block" />
          <img src={wordmark} width={200} alt="Archie" className="mt-3 dark:hidden" />
          <img src={wordmarkDark} width={200} alt="Archie" className="mt-3 hidden dark:block" />
        </div>
        <div className="bg-(--color-surface-raised) w-full max-w-md rounded-xl shadow-lg p-6 mb-8">
          <Outlet />
        </div>
      </main>
      <Footer displayNav={false} />
    </div>
  );
};

export default AuthPage;
